/* **A form dialog's parts** — the dialogs of `/rezerwacje` (Grafik's exception, block and copy;
 * Rozliczenia's four acts and help) and the client card's own, drawn once: the width, the eyebrow
 * over the title and the close, a labelled field and its input, a field's refusal, the quiet
 * sentence and the refusal line, and the acts row with the reason beside a disabled act. The
 * shell (`dialogSurface`) and its buttons stay where they are; this is what goes inside. The cards
 * beside those dialogs speak in the same two voices, so they use `note` and `refusal` from here. */

/* ── The dialogs ───────────────────────────────────────────────────────────────────────────── */
.dialog {
  --dialog-w: var(--w-booking-dialog);

  gap: var(--space-4);
}

.question {
  --dialog-w: var(--w-booking-question);

  gap: var(--space-4);
}

.dialogHead {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  justify-content: space-between;
}

.eyebrow {
  font-size: var(--fs-eyebrow);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-eyebrow);
  text-transform: uppercase;
  color: var(--text-2);
}

.dialogTitle {
  margin: var(--space-1) var(--space-0) var(--space-0);
  font-size: var(--fs-brand);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-title);
  color: var(--text);
}

.close {
  display: grid;
  flex: none;
  width: var(--h-booking-control);
  height: var(--h-booking-control);
  padding: var(--space-0);
  color: var(--text-2);
  place-items: center;
  cursor: pointer;
  background: transparent;
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
}

.questionBody {
  margin: var(--space-0);
  font-size: var(--fs-button-sm);
  line-height: var(--lh-lede);
  color: var(--text-2);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-7px);
  min-width: 0;
  margin: var(--space-0);
  padding: var(--space-0);
  border: 0;
}

.fieldLabel {
  padding: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

.input {
  min-width: 0;
  height: var(--h-control);
  padding: var(--space-0) var(--space-14px);
  font-family: var(--font-body);
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  color: var(--text);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--r-control);
}

/* A field's own refusal, under it and tied to it: the warning glyph and the sentence. */
.fieldError {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  margin: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text);
}

.dialogActs {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  justify-content: flex-end;
}

.actReason {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.note {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}

.refusal {
  margin: var(--space-10px) var(--space-0) var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--danger-ink);
}

.input.inputBad {
  border-color: var(--warn);
}

.closeGlyph {
  flex: none;
  width: var(--sz-booking-when-glyph);
  height: var(--sz-booking-when-glyph);
}

.close:focus-visible,
.input:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}
